export enum CartSections {
  CART = 'cart',
  HISTORY = 'history',
  ADDRESS = 'address',
}
